import React from 'react';
import { generatePath, Navigate, useSearchParams } from 'react-router-dom';
import track from 'react-tracking';

import { CREATE_ACCOUNT_MEMBERSHIP_PAGE_EXPERIMENT_CONFIG } from 'ab-tests/optimizely-experiments';
import EmailView from 'components/Membership/EmailView';
import { PAGE_PATHS } from 'config/routes';
import { useLocale } from 'contexts/LocaleContext/LocaleContextProvider';
import { useOptimizely } from 'contexts/OptimizelyContext/OptimizelyContext';
import { useMyProfile } from 'hooks/api/userProfiles/useFetchMyProfile/useFetchMyProfile';
import useEffectOnce from 'hooks/useEffectOnce';
import { usePageTracking } from 'utils/tracking';
import { useTrackCheckout, useTrackOnce } from 'utils/tracking/hooks';

const EmailPage = () => {
  usePageTracking();
  const { locale } = useLocale();

  const { userProfile } = useMyProfile();
  const { variants, loadScript: loadOptimizelyScript } = useOptimizely();

  const [searchParams] = useSearchParams();
  const { trackSubscriptionFunnel } = useTrackCheckout();

  useEffectOnce(() => {
    if (locale === 'en') {
      loadOptimizelyScript();
    }
  });

  const { experimentId, variations } =
    CREATE_ACCOUNT_MEMBERSHIP_PAGE_EXPERIMENT_CONFIG;
  const variantAId = variations.variantA.id;

  const isEnabledExperiment = Object.keys(variants).includes(
    experimentId.toString(),
  );
  const isVariantA = variants[experimentId] == variantAId;

  useTrackOnce(
    (setTracked) => {
      if (!userProfile) {
        trackSubscriptionFunnel('Email');
        setTracked();
      }
    },
    [userProfile, trackSubscriptionFunnel],
  );

  if (!userProfile) {
    return (
      <EmailView showPasswordInput={isEnabledExperiment ? isVariantA : false} />
    );
  }
  return (
    <Navigate
      to={{
        pathname: generatePath(PAGE_PATHS.MEMBERSHIPS.BUY_PAGE),
        search: searchParams.toString(),
      }}
    />
  );
};
export default track({ page_type: 'Memberships.Buy.Email' })(EmailPage);
